import React, { Component } from "react";
import { Form, Row, Col } from "antd";
import { ErrorMessageExceptional,InfoMessage, UserIdForm, NewSectionHeading, FormItemContainer, InfoMessageContent, ToolTipSpan, DrawerSectionContent, Snag, HitASnag, FormItem } from "./styles";
import { ContactUs, CustomisedInput,HorizontalDivider, UpdateButton } from "../../styles";
import { UpdateNewUserId, clearErrMessage } from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UpdateIDSuccess from "./UpdateIDSuccess"
import { getAccountData } from "../../../../utils/sessionUtil"
import { initiateTracking } from '../../../../utils/commonUtil';
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";
import { getAuth0UserInfo } from '../../../../Auth0/SessionProvider';
import regexMap from "../../../../utils/regexMap";

class UpdateUserIDComponent extends Component {
  state = {
    formData: {},
    old: "",
    new: "",
    confirm: "",
    confirmDirty: false,
    checked1: false,
    checked2: false,
    checked3: false,
    checked5: false,
    checked6: false,
    hasSpecial1: false,
    hasSpecial2: false,
    strengthValue: 0,
    color: "null",
    errMsgNew: '',
    isChanged: false,
    update:false,
    data:false,
    updateErrMsg:"",
    infoMsg: " "
  };

  pageTitle = "Update User ID";

  toggleIsChange = () => {
    this.setState({
      isChanged: !this.state.isChanged
    })
  }
  onEnterData=(e,type)=>{
    var hasChars = false;
    var hasSplChars = false;
    var NoEmail = false;
    this.setState({ infoMsg: " " })
    this.setState({ updateErrMsg : ''})
    if (type === "new") {
        this.setState(
          {
            new: e.target.value, errMsgNew: ''
          },
          () => {
            this.charsCount(hasChars);
            this.allowedSpecialChars(hasSplChars);
            this.NotallowedEmail(NoEmail);
          }
        );
      }
   
  }
  charsCount = () => {
    const reg = /^.{6,15}$/g;
    if (reg.test(this.state.new)) {
      this.setState(
        {
          checked1: true
        },
      );
    } else if (this.state.new === "") {
      this.setState({
        checked1: false
      });
    } else {
      this.setState({
        checked1: false
      });
    }
  };

  allowedSpecialChars = () => {
    const reg = /^[a-zA-Z0-9@_+.!#$'^`~@-]+$/g
    if (reg.test(this.state.new)) {
      this.setState(
        {
          checked2: true
        },
      );
    } else if (this.state.new === "") {
      this.setState({
        checked2: false
      });
    } else {
      this.setState({
        checked2: false
      });
    }
  };

  NotallowedEmail = () => {
    if (regexMap.emailRegEx.test(this.state.new)) {
      this.setState(
        {
          checked3: false
        },
      );
    } else if (this.state.new === "") {
      this.setState({
        checked3: true
      });
    } else {
      this.setState({
        checked3: true
      });
    }
  };
  
  handleConfirmBlur = (e, type) => {
    this.setState({ infoMsg: " " });    
      if (type == 'new') {
        if (this.state.new == "") {
          this.setState({ errMsgNew: 'Please enter User ID.' });
        } else if (!this.state.checked1){
            this.setState({errMsgNew:'User ID must be 6 to 15 letters, numbers, or characters'})
        }else if (!this.state.checked2){
          this.setState({errMsgNew:"Letters, numbers and the following characters can be used: _, +, -, ., !, #, $, ', ^, `, ~ and @"})
        }else if (!this.state.checked3){
        this.setState({errMsgNew:"Emails cannot be User IDs. Try again."})
        }else {
            this.setState({ errMsgNew: '' });
          }
      }    
  };

  getInfoMsg() {
    this.setState({ infoMsg: "Select 6 to 15 letters, numbers or characters" })
    this.setState({ errMsgNew: '' })
    this.props.clearErrMessage()
  }

  validateAllFields() {
        var err = 0;
        if (this.state.new == "") {
          this.setState({ errMsgNew: 'Please enter User ID.' })
          err++;
        } else if (!this.state.checked1){
          this.setState({errMsgNew:'User ID must be 6 to 15 letters, numbers, or characters'});
          err++;
        } else if (!this.state.checked2){
          this.setState({errMsgNew:"Letters, numbers and the following characters can be used: _, +, -, ., !, #, $, ', ^, `, ~ and @"});
          err++;
        }else if (!this.state.checked3){
          this.setState({errMsgNew:"Emails cannot be User IDs. Try again."});
          err++;
        }else {
          this.setState({ errMsgNew: '' })
        }
        if (err != 0) {
          const drawerClose = document.getElementsByClassName('ant-drawer-close');
          drawerClose[0].classList.remove('freezeclosepointer');
          this.props.changeMaskClose(false);
          return false;
        }
        return true;
   }
   updateUserId = async (dataInfo) => {
    let auth0user;
    this.setState({
      isChanged: true
    }); 
    const auth0userinfo = await getAuth0UserInfo();
    auth0user = auth0userinfo ? auth0userinfo.sub.split('|')[1] : '';
    this.props.UpdateNewUserId({
      metaData: [
        {
          method: "FORMDATA",
          url: `/donor-portal/api/user/validateUserByUsername`,
          data: dataInfo.newUserName
        },
        {
          method: "POST",
          url: `/donor-portal/api/user/${getAccountData()?.partyId}/saveUserName?auth0UserId=auth0%7C${auth0user}`,
          data: dataInfo
        }
      ]
    })
  }

  setPageTitle = (title='') => {
    if(title) {
        this.pageTitle = title;
    }
  }

  getPageTitle = () => {
      return this.pageTitle;
  }

  handleSubmit = e => {
     e.preventDefault();
     this.props.changeMaskClose(true);
     const newclas=document.getElementsByClassName('ant-drawer-close')
    newclas[0].classList.add('freezeclosepointer');
       const dataInfo = {
         "userInfo": {
           "id": this.props.id,
           "userName":this.props.userId
         },
         "userName": this.state.new.trim(),
        "newUserName":{username: this.state.new.trim()}
       }
     let validation = this.validateAllFields();
     if(validation) {
         this.updateUserId(dataInfo)
     } 
  }

  componentDidUpdate(prevProps){    
    if(this.props.apiResponseCheck !== prevProps.apiResponseCheck && this.props.apiResponseCheck ){
      this.props.changeMaskClose(true)
    }
    if(this.props.updateUserIdData) {
      initiateTracking('next', this.getPageTitle(), 'New User ID', 'Next')
    }
  }
  render() {   
    
    const { updateUserIdData,apiResponseCheck } = this.props;    
    if (updateUserIdData && updateUserIdData.toString().toLowerCase() === 'ok') {
     this.state.isChanged = true;
    } else {
      this.state.isChanged = false;
    }  

    if(apiResponseCheck==true){
      const newclas=document.getElementsByClassName('ant-drawer-close')
      newclas[0].classList.remove('freezeclosepointer');      
    }

    return (
      <>        
        {this.state.isChanged === false ? (<div>
          <NewSectionHeading>
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_4_title" defaultMessage="Update User ID" setTitle={this.setPageTitle} />
          </NewSectionHeading>
          <DrawerSectionContent className="mb-50">
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" html={true} property="field_type_4_description" defaultMessage="<p>To update your User ID, select 6 to 15 letters, numbers, or characters. The User ID is not case sensitive.</p>" />
          </DrawerSectionContent>
          <Row>
            <Col lg={13} md={13}>
              <UserIdForm onSubmit={this.handleSubmit}>
                <FormItem label="User ID">
                  <CustomisedInput value={this.props.userId} disabled className="securityQuesAnswer"/>
                </FormItem>
               
                <FormItemContainer label="New User ID">
                  
                    <CustomisedInput                      
                      data-test="userid-input"
                      id="txtNewUserId"
                      placeholder="Enter new User ID"
                      setFieldsValue={this.state.new}
                      onChange={e => this.onEnterData(e, "new")}
                      onBlur={e => this.handleConfirmBlur(e, "new")}
                      onFocus={this.getInfoMsg.bind(this)}
                      maxLength="15"
                      className="securityQuesAnswer"
                    />
                   
                    <ErrorMessageExceptional>{this.state.errMsgNew}</ErrorMessageExceptional>
                    {this.props.useridExists?(<ErrorMessageExceptional>{this.props.useridExists}</ErrorMessageExceptional>):(null)}
                    {(this.props.useridExistsBefore==true)?(<ErrorMessageExceptional>User ID is taken. Try again.</ErrorMessageExceptional>):(null)}
                  {this.state.infoMsg!=" " ? (                  
                        <InfoMessage><ToolTipSpan></ToolTipSpan><InfoMessageContent>{this.state.infoMsg}</InfoMessageContent></InfoMessage>
                         ) : (null)}
                </FormItemContainer>
                <Form.Item>
                  <GeneralButton
                    type="functional"
                    text="SAVE"
                    htmlType="submit"
                    disabled={!this.state.errMsgNew ? false : true}
                    id="btnSubmit"
                    maxWidth="990px"
                    fontSize="18px"
                    styling="mt-10"
                    width="60%"
                    mobWidth="100%"
                  />
                </Form.Item>
              </UserIdForm>
                            
            </Col>
          </Row>
          <HorizontalDivider />
          <Row>
          <Col>
          <HitASnag style={Snag}>                                
                  <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_8_title" defaultMessage="Hit a Snag?" />
              </HitASnag>
              <ContactUs>
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_type_8_description" defaultMessage="<p>Contact us: <br> <span class='updateUserIdSnagContent'>888-383-4483</span> or <br> <span class='updateUserIdSnagContent'>https://www.vanguardcharitable.org/contact-us</span></p>"/>
              </ContactUs>
              </Col>
              </Row>
              
        </div>) : (
          <UpdateIDSuccess userid={this.props.userId} newUserId={this.state.new} closeDrawer={this.props.onClose}/>
        )
        }     
      </>
    );
  }
}

UpdateUserIDComponent.propTypes = {
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  id: PropTypes.number,
  changeMaskClose: PropTypes.func.isRequired
}

const WrappedRegistrationForm = Form.create({ name: "register" })(
  UpdateUserIDComponent
);

const mapStateToProps = state => ({  
  accountID: state.getIn(["globalState", "accountID"]),  
  updateUserIdData: state.getIn(["myAccount", "updateUserIdData"]),
  useridExists: state.getIn(["myAccount","useridExists"]),
  useridExistsBefore: state.getIn(["myAccount","useridExistsBefore"]),
  apiResponseCheck: state.getIn(["myAccount","apiFlag"])
});

export const mapDispatchToProps = dispatch => ({  
    UpdateNewUserId: data => dispatch(UpdateNewUserId(data)) ,
    clearErrMessage: () => dispatch(clearErrMessage())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WrappedRegistrationForm)
);
